import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { combineLatest, filter } from 'rxjs';
import {
  selectAddingWorkspaceDocuments,
  selectWorkspaceCreating,
} from 'src/app/modules/workspaces/store/selectors';
import { AppState } from '../../../store/state';
import { isPresent } from '../../../utils/isPresent';

@UntilDestroy()
@Component({
  selector: 'app-workspace-documents-loader-notification',
  templateUrl: './workspace-documents-loader-notification.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class WorkspaceDocumentsLoaderNotificationComponent implements OnInit {
  public creatingWorkspace: boolean = false;
  public addingWorkspaceDocuments: boolean = false;

  constructor(
    private store$: Store<AppState>,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    combineLatest([
      this.store$.select(selectWorkspaceCreating).pipe(filter(isPresent)),
      this.store$.select(selectAddingWorkspaceDocuments).pipe(filter(isPresent)),
    ])
      .pipe(untilDestroyed(this))
      .subscribe(([creatingWorkspace, addingWorkspaceDocuments]) => {
        this.creatingWorkspace = creatingWorkspace;
        this.addingWorkspaceDocuments = addingWorkspaceDocuments;
        this.cdr.markForCheck();
      });
  }
}
